import { func, bool, string } from 'prop-types'
import { Modal } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import AccountSettings from '../AccountSettings'
import './styles.scss'

const AccountSettingsModal = ({
  accountId,
  accountName,
  channelColor,
  channelName,
  channelType,
  onClose,
  onPlacementChange,
  onSubmit,
  visible,
}) => (
  <AnalyticsLayer name="Account Options Modal">
    <Modal
      customClassname="account-settings-modal"
      shouldConfirmExit={false}
      visible={visible}
      onClose={onClose}
    >
      <AccountSettings
        accountId={accountId}
        accountName={accountName}
        channelColor={channelColor}
        channelName={channelName}
        channelType={channelType}
        onPlacementChange={onPlacementChange}
        onSubmit={onSubmit}
      />
    </Modal>
  </AnalyticsLayer>
)

AccountSettingsModal.propTypes = {
  accountId: string,
  accountName: string,
  channelColor: string,
  channelName: string,
  channelType: string,
  onClose: func,
  onPlacementChange: func,
  onSubmit: func,
  visible: bool,
}

export default AccountSettingsModal
